<template>
	<div>
		<div class="row">
			<div class="col-lg-4">
				<label for="">Tipo de Usuario *</label>
				<select @change="LimpiarUsuario" v-model="ProyectoPersonal.TipoUsuario" class="form-control">
					<option value="">- Tipo -</option>
					<option value="1">Usuario Desprosoft</option>
					<option value="2">Usuario Externo</option>
					<Cvalidation v-if="this.errorvalidacion.TipoUsuario" :Mensaje="errorvalidacion.TipoUsuario[0]"></Cvalidation>
				</select>
			</div>
			<div class="col-lg-4" v-if="ProyectoPersonal.TipoUsuario=='1'">
				<label for="">Selecciona Usuario</label>
				<select v-model="ProyectoPersonal.IdUsuario" class="form-control" @change="SeleccionarUsuario">
					<option value="">- Usuario -</option>
					<option v-for="(item,index) in ListaUsuarios" :value="item.IdUsuario" :key="index">{{item.Nombre}}</option>
				</select>
			</div>
		</div>
		<div class="row mt-4">
			<div class="col-lg-4">
				<div class="avatar-upload">
					<div class="avatar-edit" v-show="ProyectoPersonal.TipoUsuario=='2'">
						<input
							id="file2"
							ref="file2"
							type="file"
							name="myfile2"
							@change="uploadImage()"
							accept=".png, .jpg, .jpeg"
						/>
						<label for="file2"></label>
					</div>
					<div class="avatar-preview">
						<div
							id="imagePreview2"
							style="background-image: url(Img);"
						></div>
					</div>
				</div>
			</div>
			<div class="col-lg-8">
				<div class="row">
					<div class="col-lg-6">
						<label for="">Nombre</label>
						<input :disabled="ProyectoPersonal.TipoUsuario=='1'" type="text" class="form-control" v-model="ProyectoPersonal.Nombre"/>
					</div>
					<div class="col-lg-6">
						<label for="">Posición</label>
						<input :disabled="ProyectoPersonal.TipoUsuario=='1'" type="text" class="form-control" v-model="ProyectoPersonal.Posicion"/>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-lg-6">
						<label for="">Profesión</label>
						<input :disabled="ProyectoPersonal.TipoUsuario=='1'" type="text" class="form-control" v-model="ProyectoPersonal.Profesion"/>
					</div>
					<div class="col-lg-6">
						<label for="">Correo</label>
						<input :disabled="ProyectoPersonal.TipoUsuario=='1'" type="text" class="form-control" v-model="ProyectoPersonal.Correo"/>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-lg-6">
						<label for="">Telefono</label>
						<input :disabled="ProyectoPersonal.TipoUsuario=='1'" type="text" class="form-control" v-model="ProyectoPersonal.Telefono"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $$ from "jquery";
import Cvalidation from '@/components/Cvalidation.vue'
export default {
	name:"Personal",
    props:["poBtnSave","pIdProyecto"],
	components:{Cvalidation},
	data() {
		return {
			Modal:true,
            FormName:'Personal',
			EmitSeccion:this.poBtnSave.EmitSeccion,
			ProyectoPersonal:{
				IdProyectoPersonal:0,
				IdProyecto:0,
				IdUsuario:0,
				Nombre:'',
				Profesion:'',
				Posicion:'',
				Correo:'',
				Telefono:'',
				TipoUsuario:'',
				Foto:'',
			},
			Foto:'',
			RutaFoto:'',
			RutaFotoProyectoPersonal:'',
			errorvalidacion:[],
			ListaUsuarios:[]
		}
	},
	methods: {
		async Guardar(){
			let formData=new FormData();
            formData.set('IdProyectoPersonal',this.ProyectoPersonal.IdProyectoPersonal);
			formData.set('IdProyecto',this.ProyectoPersonal.IdProyecto);
			formData.set('IdUsuario',this.ProyectoPersonal.IdUsuario);
			formData.set('TipoUsuario',this.ProyectoPersonal.TipoUsuario);
			formData.set('Nombre',this.ProyectoPersonal.Nombre);
			formData.set('Profesion',this.ProyectoPersonal.Profesion);
			formData.set('Posicion',this.ProyectoPersonal.Posicion);
			formData.set('Telefono',this.ProyectoPersonal.Telefono);
			formData.set('Correo',this.ProyectoPersonal.Correo);
			formData.set('Foto',this.ProyectoPersonal.Foto);
			let file = this.$refs.file2.files[0];
			formData.append("FotoFile", file);
			this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			await this.$http.post('proyectopersonal/post',formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res)=>{
				this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Personal").modal("hide");
				// this.bus.$emit('List');
                this.bus.$emit('ListaPrincipal');
			}).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
		},
		async Recuperar(){
			await this.$http.get('proyectopersonal/recovery',{
				params:{
					IdProyectoPersonal:this.ProyectoPersonal.IdProyectoPersonal
				}
			}).then((res)=>{
				const objres=res.data.data.proyectopersonal;
				this.RutaFoto=res.data.data.rutatrabajador;
				this.RutaFotoProyectoPersonal=res.data.data.rutaproyectopersonal;
				this.ProyectoPersonal.IdProyectoPersonal=objres.IdProyectoPersonal;
				this.ProyectoPersonal.IdProyecto=objres.IdProyecto;
				this.ProyectoPersonal.IdUsuario=objres.IdUsuario;
				this.ProyectoPersonal.Nombre=objres.Nombre;
				this.ProyectoPersonal.Profesion=objres.Profesion;
				this.ProyectoPersonal.Posicion=objres.Posicion;
				this.ProyectoPersonal.Correo=objres.Correo;
				this.ProyectoPersonal.Telefono=objres.Telefono;
				this.ProyectoPersonal.Foto=objres.Foto;
				this.ProyectoPersonal.TipoUsuario=objres.TipoUsuario;
				this.Foto=this.ProyectoPersonal.TipoUsuario=='1' ? objres.Foto2 : objres.Foto;
				if (this.ProyectoPersonal.TipoUsuario=='1') {
					this.SeleccionarUsuario();
					this.readURL(this.RutaFoto+this.Foto);
				}
				else{
					this.readURL(this.RutaFotoProyectoPersonal+this.ProyectoPersonal.Foto);
				}
			})
		},
		Limpiar(){
			this.ProyectoPersonal={
				IdProyectoPersonal:0,
				IdProyecto:0,
				IdUsuario:0,
				Nombre:'',
				Profesion:'',
				Posicion:'',
				Correo:'',
				Telefono:'',
				TipoUsuario:'',
				Foto:'',
			};
			this.Foto='';
			this.errorvalidacion=[];
			this.readURL('');
		},
		LimpiarUsuario(){
			this.ProyectoPersonal.IdUsuario=0;
			this.ProyectoPersonal.Nombre='';
			this.ProyectoPersonal.Correo='';
			this.ProyectoPersonal.Profesion='';
			this.ProyectoPersonal.Posicion='';
			this.ProyectoPersonal.Telefono='';
			this.ProyectoPersonal.Foto='';
			this.Foto='';
			// this.errorvalidacion=[];
			this.readURL('');
		},
		async GetUsuario(){
			await this.$http.get('trabajador/get', {
                params: { RegEstatus: "A" },
            }).then((res)=>{
				let Mapeado=res.data.data.todos.map((Element)=>{
                    if (Element.IdUsuario==null) {
                        Element.IdUsuario=Element.TrabajadorUsuario,
                        Element.Nombre=Element.NombreAdmin
                        return Element;
                    }
                    else{
                        return Element;
                    }
                });
                this.ListaUsuarios=Mapeado;
				this.RutaFoto=res.data.data.rutatrabajador;
			}).finally(()=>{
				if (this.ProyectoPersonal.IdProyectoPersonal>0) {
					this.Recuperar();
				}
			})
		},
		SeleccionarUsuario(){
			let Index=this.ListaUsuarios.findIndex((value) => value.IdUsuario==this.ProyectoPersonal.IdUsuario);
			if(Index!=-1){
				this.ProyectoPersonal.Nombre=this.ListaUsuarios[Index].Nombre;
				this.ProyectoPersonal.Profesion=this.ListaUsuarios[Index].Profesion;
				this.ProyectoPersonal.Posicion=this.ListaUsuarios[Index].Categoria;
				this.ProyectoPersonal.Correo=this.ListaUsuarios[Index].Usuario;
				this.ProyectoPersonal.Telefono=this.ListaUsuarios[Index].Telefono;
				this.Foto=this.ListaUsuarios[Index].Foto2;
				this.readURL(this.RutaFoto+this.Foto);
			}
			// console.log(this.ListaUsuarios[Index]);
		},
		uploadImage() {
			this.ProyectoPersonal.Foto = this.$refs.file2.files[0];
			const image = this.$refs.file2.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.Img = e.target.result;
				this.readURL(this.Img);
			};
		},
		readURL(input) {
			$$("#imagePreview2").css("background-image", "url(" + input + ")");
			$$("#imagePreview2").hide();
			$$("#imagePreview2").fadeIn(650);
		},
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdProyecto)=>{
			// console.log("a");
			this.GetUsuario();
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdProyecto!==undefined) {
                this.ProyectoPersonal.IdProyecto=IdProyecto;
            }
            if (Id > 0) {
				this.ProyectoPersonal.IdProyectoPersonal = Id;
				this.Recuperar();
			}
        });
	},
}
</script>

<style>

</style>
